export const LOAD_REQUESTED = "LISTOFDOCUMENT/LOAD_REQUESTED";
export const LOAD_SUCCESS = "LISTOFDOCUMENT/LOAD_SUCCESS";
export const LOAD_FAIL = "LISTOFDOCUMENT/LOAD_FAIL";

export default (state = {}, { type }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return state;
    }
    case LOAD_SUCCESS: {
        return state;
    }
    case LOAD_FAIL: {
        return state;
    }
    default: return state;
    }
};

export const requestLoadlistofdocument = data => ({ type: LOAD_REQUESTED, data });
export const successLoadlistofdocument = data => ({ type: LOAD_SUCCESS, data });
export const failLoadlistofdocument = data => ({ type: LOAD_FAIL, data });
